import { nonFormNoteSchemas } from 'constants/note-schemas';
export var linkToAppointment = function (appointmentId) { return "/appointment/".concat(appointmentId, "/note"); };
/**
 * Returns the route to the appointment's note.
 *
 * @param {string} appointmentId appointmentId
 * @param {AppointmentNoteIndex} notesIndexedByAppointmentId notesIndexedByAppointmentId
 * @returns {string} the route to the appointment's note
 */
export var linkToNote = function (appointmentId, notesIndexedByAppointmentId) {
    return notesIndexedByAppointmentId
        ? notesIndexedByAppointmentId[appointmentId]
            ? "/appointment/".concat(appointmentId, "/note/").concat(notesIndexedByAppointmentId[appointmentId].id)
            : linkToAppointment(appointmentId)
        : '';
};
export var linkToMemberMeasures = function (memberId) {
    return "/client/".concat(memberId, "/assessments");
};
export var linkToNoteOrAppointment = function (appointmentId, noteId) {
    return noteId ? "/appointment/".concat(appointmentId, "/note/").concat(noteId) : linkToAppointment(appointmentId);
};
export var linkToNoteOrPlaceholder = function (noteOrPlaceholder) {
    var _a;
    if (((_a = noteOrPlaceholder.note) === null || _a === void 0 ? void 0 : _a.noteSchema) === nonFormNoteSchemas.legacyImport) {
        return "/client/".concat(noteOrPlaceholder.member.id, "/kareo/").concat(noteOrPlaceholder.note.id);
    }
    if (noteOrPlaceholder.appointment && noteOrPlaceholder.note) {
        return "/appointment/".concat(noteOrPlaceholder.appointment.id, "/note/").concat(noteOrPlaceholder.note.id);
    }
    if (noteOrPlaceholder.appointment && !noteOrPlaceholder.note) {
        return linkToAppointment(noteOrPlaceholder.appointment.id);
    }
    if (!noteOrPlaceholder.appointment && noteOrPlaceholder.note) {
        // this won't currently occur where we call this, but including for completeness
        return "/client/".concat(noteOrPlaceholder.member.id, "/unscheduled-interaction/").concat(noteOrPlaceholder.note.id);
    }
    if (!noteOrPlaceholder.appointment && !noteOrPlaceholder.note) {
        // this won't currently occur where we call this, but including for completeness
        return "/client/".concat(noteOrPlaceholder.member.id, "/unscheduled-interaction");
    }
    return '404';
};
